// Iter 83 — Extracted from TradeDoctor.jsx (was lines ~1622-1730).
// Strengths card grid. Each card shows title + one-sentence evidence
// quoting user's own numbers + a short encouraging note.
import React from "react";
import { Award } from "lucide-react";

export function StrengthsCards({ strengths, testid }) {
  const list = Array.isArray(strengths) ? strengths : [];
  if (list.length === 0) {
    return (
      <div
        data-testid={testid}
        className="bt-card border border-[var(--bt-border)] bg-[var(--bt-surface)] rounded-sm p-5"
      >
        <div className="flex items-center gap-2 mb-2">
          <Award className="w-5 h-5" style={{ color: "var(--bt-win)" }} />
          <h3 className="font-heading text-base">Your Strengths</h3>
        </div>
        <p className="text-sm text-[var(--bt-text-muted)]">
          No clear strengths yet — keep logging.
        </p>
      </div>
    );
  }
  return (
    <div data-testid={testid} className="space-y-3">
      <div className="flex items-center gap-2">
        <Award className="w-5 h-5" style={{ color: "var(--bt-win)" }} />
        <h3 className="font-heading text-base">Your Strengths</h3>
        <span className="text-xs text-[var(--bt-text-muted)] ml-auto">
          {list.length} {list.length === 1 ? "strength" : "strengths"} · protect these
        </span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {list.map((s, i) => (
          <StrengthCard key={i} strength={s} index={i} />
        ))}
      </div>
    </div>
  );
}

export function StrengthCard({ strength, index }) {
  const evidence = (strength?.evidence || "").trim() || (strength?.detail || "").trim();
  const note = (strength?.note || "").trim();
  return (
    <div
      data-testid={`strength-card-${index}`}
      className="rounded-sm border p-4 space-y-2"
      style={{
        borderColor: "color-mix(in srgb, var(--bt-win) 45%, var(--bt-border))",
        background: "color-mix(in srgb, var(--bt-win) 4%, var(--bt-surface))",
      }}
    >
      <h4
        className="font-heading text-sm leading-snug line-clamp-2"
        title={strength?.title || ""}
      >
        {strength?.title || "Unnamed strength"}
      </h4>
      {evidence && (
        <p
          data-testid={`strength-card-${index}-evidence`}
          className="text-xs leading-relaxed"
          style={{ color: "var(--bt-text-muted)" }}
        >
          {evidence}
        </p>
      )}
      {note && (
        <p
          data-testid={`strength-card-${index}-note`}
          className="text-xs italic"
          style={{ color: "var(--bt-win)" }}
        >
          {note}
        </p>
      )}
    </div>
  );
}
